//src/hooks/useTableReset.ts
import { useCallback, useState } from 'react';

/** Унифицированный сброс колонок таблицы по ключу localStorage */
export function useTableReset(storageKey: string) {
  const [version, setVersion] = useState(0);
  const reset = useCallback(() => {
    try { localStorage.removeItem(storageKey); } catch {}
    setVersion(v => v + 1);
  }, [storageKey]);
  return [version, reset] as const;
}
